module.exports = __webpack_public_path__ + "static/media/bg-intro-top-com.67bff4c2.png";